import { FeatureFlagIdCopilotInsights } from 'c1gen/features'
import { C1Icon } from 'components/core/icons/C1Icon'
import { CopilotIcon } from 'components/core/icons/copilot'
import { useFeatureCheckerLazy } from 'components/no-ui/capability'
import { sxc } from 'components/no-ui/styles/styleTypes'
import { TaskValue } from 'lib/actions/task'
import { CircleAlert } from 'lucide-react'
import { InsightRecommendation } from 'pbts/c1/api/task/v1/insights'
import React, { FC } from 'react'
import { TaskActionButton } from './styles'

export const DenyIcon: FC<{ task: TaskValue, variant?: 'white' | 'blue' }> = ({ task, variant = 'blue' }) => {
    const hasFeature = useFeatureCheckerLazy()
    const recommendDeny = hasFeature(FeatureFlagIdCopilotInsights) && task.recommendation === InsightRecommendation.DENY

    if (recommendDeny) {
        return <CopilotIcon sx={sxc(TaskActionButton.insightsIcon, [variant === 'white', TaskActionButton.whiteIcon])} />
    }
    return null
}

export const ApproveIcon: FC<{ task: TaskValue }> = ({ task }) => {
    const hasFeature = useFeatureCheckerLazy()
    const recommendReview = hasFeature(FeatureFlagIdCopilotInsights) && task.recommendation === InsightRecommendation.REVIEW

    if (recommendReview) {
        return <C1Icon icon={CircleAlert} sx={TaskActionButton.insightsReviewIcon} />
    }
    return null
}
